import { useQuery } from 'react-query';
import { useResourcesApi } from 'services/api';

export const useFieldTypes = entityType => {
    const { getPushApiFieldTypes } = useResourcesApi();
    const { data, isLoading, isError } = useQuery(
        ['fieldTypes', entityType],
        async () => {
            const data = await getPushApiFieldTypes(entityType);

            return data?.map(item => ({
                value: item.name,
                label: item.value,
            }));
        },
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        }
    );
    return { data, isLoading, isError };
};
